
import Vue from 'vue'
import SchoolSelection from './School/SchoolSelection.vue'

export default Vue.extend({
   name: 'SchoolOrderDetails',
   data() {
      return {
         editing: false,
      }
   },
   computed: {
      hasSchool(): boolean {
         return this.hasLookedUpSchool || this.hasAlreadyAssociatedSchool
      },
      hasAlreadyAssociatedSchool(): boolean {
         return !!this.$store.state.modelData.SchoolId
      },
      hasLookedUpSchool(): boolean {
         return !!this.$store.state.schoolLookup.schoolId
      },
      schoolName(): string {
         return this.$store.getters.schoolName
      },
      schoolAddress(): string {
         if (!this.hasSchool) {
            return ''
         }
         return this.hasLookedUpSchool
            ? this.$store.state.schoolLookup.schoolAddress
            : this.$store.state.modelData.SchoolAddress
      },
   },
   methods: {
      schoolSelected() {
         this.editing = false
      },
   },
   components: {
      SchoolSelection,
   },
})
